import { REVISION as c } from "three";
import { RgCoreVersion as a } from "@project-rouge/rg-core";
const s = "150", u = "^16.1.0", i = (e) => e.split(".")[0].replace("^", "").replace("~", "");
function g(e = !1) {
  if (s === `${c}`)
    return;
  const r = `three expected to be ${s}, but is ${c}`;
  if (e)
    throw new Error(r);
  console.warn(r);
}
function h({ errorIfMismatch: e, dependency: r, expected: o, current: n }) {
  const p = i(o), f = i(n);
  if (p === f)
    return;
  const t = `${r} expected to be ${o}, but is ${n}`;
  if (e)
    throw new Error(t);
  console.warn(t);
}
function l(e = !1) {
  g(e), h({
    errorIfMismatch: e,
    dependency: "rg-core",
    expected: u,
    current: a
  });
}
l();
export {
  l as RgThreePeersCheck
};
//# sourceMappingURL=index.js.map
